// extracted by mini-css-extract-plugin
export var orderSummary = "_sm-0";
export var showMoreLessButton = "_sm-1";